import { jsx } from "react/jsx-runtime";
import { PillBadge } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
const PillBadgesList = ({
  pillBadges,
  dataPrivate,
  uniqueId = "",
  componentType
}) => {
  return pillBadges == null ? void 0 : pillBadges.map((item, index) => /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: ["badge pill", item.text],
          type: "nav"
        },
        trackType: "navigation"
      },
      children: /* @__PURE__ */ jsx(
        PillBadge,
        {
          ...item,
          componentType,
          dataPrivate: Boolean(dataPrivate),
          uniqueId: `${item.text}_${uniqueId}`
        },
        item.text
      )
    },
    item.text + `-${index}-analytics`
  ));
};
export {
  PillBadgesList
};
